// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2oMns","colMaxWidth":"Table_colMaxWidth__2wR9a"};